import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var NewspaperIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M20.355 21.355H3.235c-.69 0-1.34-.27-1.83-.76-.48-.48-.76-1.15-.76-1.83V4.435c0-.47.19-.94.53-1.27a1.8 1.8 0 011.27-.52h15.13c.48 0 .93.19 1.27.53.33.33.53.8.53 1.27v13.93c0 .26.1.51.29.7.37.37 1.03.37 1.4 0 .19-.19.29-.44.29-.7V8.015c0-.55.45-1 1-1s1 .45 1 1v10.35c0 .8-.31 1.55-.88 2.11-.57.56-1.33.88-2.11.88h-.01zM2.645 4.635v14.13c0 .16.06.31.17.42.11.11.26.17.42.17h14.29c-.11-.31-.17-.65-.17-.99V4.635H2.645z"
                        }),
                        _jsx("path", {
                            d: "M13.585 12.595h-7.17c-.55 0-1-.45-1-1v-3.98c0-.55.45-1 1-1h7.17c.55 0 1 .45 1 1v3.98c0 .55-.45 1-1 1zm-6.17-2h5.17v-1.98h-5.17v1.98zm6.17 6.78h-7.17c-.55 0-1-.45-1-1s.45-1 1-1h7.17c.55 0 1 .45 1 1s-.45 1-1 1z"
                        })
                    ]
                })
            })
        ]
    });
};
NewspaperIcon.isCarinaIcon = true;
export default NewspaperIcon;
